__turbopack_context__.v({
  "Container": "HighlightedText-module-scss-module__FJ9KXW__Container",
  "LightGrey": "HighlightedText-module-scss-module__FJ9KXW__LightGrey",
});
